// Mappers for device-related entities
// Identity mappers for 1:1 mapping

import type {
  AddDeviceResponseDto,
  SubmitDeviceDetailsResponseDto,
  DeleteDeviceResponseDto,
  SearchDevicesResponseDto,
  SubmitDeviceActivationDetailsResponseDto,
  AuthenticateDeviceResponseDto,
  CheckPendingActivationsResponseDto,
} from '../../generated/models';

import type {
  AddDeviceResponse,
  SubmitDeviceDetailsResponse,
  DeleteDeviceResponse,
  SearchDevicesResponse,
  SubmitDeviceActivationDetailsResponse,
  AuthenticateDeviceResponse,
  CheckPendingActivationsResponse,
} from '../types';

// Response mappers (identity for 1:1)
export const toAddDeviceResponse = (dto: AddDeviceResponseDto): AddDeviceResponse => dto;
export const toSubmitDeviceDetailsResponse = (dto: SubmitDeviceDetailsResponseDto): SubmitDeviceDetailsResponse => dto;
export const toDeleteDeviceResponse = (dto: DeleteDeviceResponseDto): DeleteDeviceResponse => dto;
export const toSearchDevicesResponse = (dto: SearchDevicesResponseDto): SearchDevicesResponse => dto;
export const toSubmitDeviceActivationDetailsResponse = (
  dto: SubmitDeviceActivationDetailsResponseDto
): SubmitDeviceActivationDetailsResponse => dto;
export const toAuthenticateDeviceResponse = (dto: AuthenticateDeviceResponseDto): AuthenticateDeviceResponse => dto;
export const toCheckPendingActivationsResponse = (
  dto: CheckPendingActivationsResponseDto
): CheckPendingActivationsResponse => dto;
